import { useEffect } from "react";
import styles from "./style.module.scss";

import EstadoCuentaIcon from '@assets/icons-png/estado-cuenta.png';
import ListaPreciosIcon from '@assets/icons-png/cropped_icons_with_padding/icon_4_6.png';
import PieChartIcon from '@assets/icons-png/cropped_icons_with_padding/icon_49.png';
import PageContainer from "@components/layout/PageContainer";
import DashboarLinksSection, { DashboardLinksSectionProps } from "@components/content/DashboardLinksSection";
import ListPriceGeneratorOffCanvas from "@components/layout/Offcanvas/ListPriceGeneratorOffCanvas";
import { OpenListPriceGeneratorPubSub } from "@utils/pubsubs/PubSub";

const InventoryDashboard = () => {

  const groupLinks: DashboardLinksSectionProps[] = [
    {
      title: "Reportes Generales",
      links: [
        {
          icon: EstadoCuentaIcon,
          iconAlt: "Reporte Inventario",
          title: "Reporte Inventario",
          url: "/user/reports/inventory",
          target: "_blank"
        },
        {
          icon: PieChartIcon,
          iconAlt: "Icono Exportar Inventario a Excel",
          title: "Exportar Inventario a Excel",
          url: "/user/reports/product-export",
          target: "_blank"
        },
        {
          icon: PieChartIcon,
          iconAlt: "Icono Reporte por Categoria",
          title: "Reporte por Categoria",
          url: "/user/reports/products-by-category"
        },
        {
          icon: ListaPreciosIcon,
          iconAlt: "Icono Lista de Precios",
          title: "Lista de Precios",
          url: "#",
          onClick: () => {
            OpenListPriceGeneratorPubSub.publish({ openOffCanvas: true })
          }
        }
      ]
    },
    {
      title: "Reporte Movimiento Inventario",
      links: [{
        icon: EstadoCuentaIcon,
        iconAlt: "Icono Historial Ventas",
        title: "Historial Ventas",
        url: "/user/reports/sales-by-products"
      },
      // {
      //   icon: EstadoCuentaIcon,
      //   iconAlt: "Icono Historial por Categoria",
      //   title: "Historial por Categoria",
      //   url: "/user/reports/sales-by-categories"
      // },
      {
        icon: EstadoCuentaIcon,
        iconAlt: "Icono Ventas por Cliente",
        title: "Ventas por Cliente",
        url: "/user/reports/sales-by-clients"
      },
      ]
    }
  ]

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Reportes de Inventario"
      backUrl="/user/products"
    >
      {
        groupLinks.map(gl => {
          return (
            <DashboarLinksSection
              title={gl.title}
              links={gl.links}
            />
          )
        })
      }
      <ListPriceGeneratorOffCanvas />
    </PageContainer>
  );
}

export default InventoryDashboard;
